export { MainTabs } from './MainTabs'
